const requireSvg = require.context('!vue-svg-loader!@/assets/icons', true, /\.svg$/);
const icons = {};

requireSvg.keys().forEach((filename) => {
  const icon = requireSvg(filename);
  const iconName = filename.replace(/^.+\/([^/]+)\.svg$/, '$1');
  icons[iconName] = icon;
});

export default icons;
